

import iconEmail from './Component/assets/icon-email.svg'
import iconPhone from './Component/assets/icon-phone.svg'
import iconWhatsApp from './Component/assets/icon-whatsapp.svg'

const MAP_PAGES = {
    DEFAULT: 0,
    PHONE: 1,
    EMAIL: 2,
    WHATSAPP: 3 
}

const MAP_SUPPORT_OPTIONS = [
    {
        label: 'WhatsApp',
        icon: iconWhatsApp,
        content: 'Ask a question via WhatsApp',
        alternateContent: 'Only available on weekdays (Monday to Friday) between 10:00 AM to 06:00 PM',
        pageId: MAP_PAGES.WHATSAPP
    },
    {
        label: 'Email',
        icon: iconEmail,
        content: 'Ask a question and we\'ll reply by email.',
        pageId: MAP_PAGES.EMAIL
    },
    {
        label: 'Phone',
        icon: iconPhone,
        content: 'Confirm your phone number and we\'ll give you a call.',
        alternateContent: 'Only available on weekdays (Monday to Friday) between 10:00 AM to 06:00 PM',
        pageId: MAP_PAGES.PHONE
    }
]

const WHATSAPP_REDIRECTION = 'https://wa.me/+919555553311'

const STRING_MAIN_HEAD = 'How would you like to get help?'
const STRING_MAIN_SUB_HEAD = 'Choose the option that is most convenient to you'

const STRING_PHONE_HEAD = 'Share your phone number with us.'
const STRING_PHONE_SUB_HEAD = 'We\'ll connect you with our customer support representative.'

const STRING_EMAIL_HEAD = 'Send us a message.'
const STRING_EMAIL_SUB_HEAD = 'We\'ll review your message and reply by email.'

const STRING_BUTTON_CANCEL = 'CANCEL'
const STRING_BUTTON_SUBMIT = 'SUBMIT'
const STRING_BUTTON_CONNECT = 'CONNECT'

export default { 

    MAP_SUPPORT_OPTIONS,

    MAP_PAGES,

    WHATSAPP_REDIRECTION,

    STRING_MAIN_HEAD,
    STRING_MAIN_SUB_HEAD,

    STRING_PHONE_HEAD,
    STRING_PHONE_SUB_HEAD,

    STRING_EMAIL_HEAD,
    STRING_EMAIL_SUB_HEAD,

    STRING_BUTTON_CANCEL,
    STRING_BUTTON_SUBMIT,
    STRING_BUTTON_CONNECT

};
